export default {
      id: "filled-list-usage",
      viewBox: "0 0 36 36",
      url: __webpack_public_path__ + "sprite.svg#filled-list",
      toString: function () {
        return this.url;
      }
    }